var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalloutLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2C9.5 2 6.45893 3.52053 2.03405 6.89305C0.99179 7.68743 1.03492 9.26197 2.13268 9.9777C5.84324 12.397 7.00865 12.2178 10 13.5L9.5 2Z",
    stroke: "#EFEFF4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C12 2 6.34365 5.57243 3.30068 7.43386C2.58309 7.87281 2.64481 9.01572 3.41779 9.34755C7.84969 11.2501 10.9252 12.1821 14 13.5L12 2Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalloutLeft);
export default __webpack_public_path__ + "static/media/CalloutLeft.0f076afd0a1cf19d7e7b62e6c1897fa0.svg";
export { ForwardRef as ReactComponent };